import {
  MeetingProvider,
  UserActivityProvider,
} from 'amazon-chime-sdk-component-library-react'
import { ChimeMeeting } from './ChimeMeeting'

export const ChimeCabinLivestream = ({
  credentials,
  vehicleId,
}: {
  credentials: string
  vehicleId: string
}) => {
  return (
    <UserActivityProvider>
      <MeetingProvider>
        <ChimeMeeting credentials={credentials} vehicleId={vehicleId} />
      </MeetingProvider>
    </UserActivityProvider>
  )
}
